module.exports = __webpack_public_path__ + "img/desenhando.74292546.svg";